const API_BASE = 'https://ecommerce-api.lixxon.workers.dev'

class ApiError extends Error {
  constructor(message, status, details) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.details = details;
  }
}

const handleResponse = async (response) => {
  const data = await response.json();
  
  if (!response.ok) {
    throw new ApiError(
      data.error || 'API request failed',
      response.status,
      data
    );
  }
  
  return data;
};

export const api = {
  async getProducts(category = null) {
    try {
      const url = category ? `${API_BASE}/api/products?category=${category}` : `${API_BASE}/api/products`;
      const response = await fetch(url);
      return await handleResponse(response);
    } catch (error) {
      console.error('API Error in getProducts:', error);
      throw error;
    }
  },

  async getProduct(id) {
    try {
      const response = await fetch(`${API_BASE}/api/products/${id}`);
      return await handleResponse(response);
    } catch (error) {
      console.error('API Error in getProduct:', error);
      throw error;
    }
  },

  async createProduct(product, adminKey) {
    try {
      const response = await fetch(`${API_BASE}/api/products`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Admin-Key': adminKey,
        },
        body: JSON.stringify(product),
      });
      
      return await handleResponse(response);
    } catch (error) {
      console.error('API Error in createProduct:', error);
      throw error;
    }
  },

  async updateProduct(id, product, adminKey) {
    try {
      const response = await fetch(`${API_BASE}/api/products/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Admin-Key': adminKey,
        },
        body: JSON.stringify(product),
      });
      
      return await handleResponse(response);
    } catch (error) {
      console.error('API Error in updateProduct:', error);
      throw error;
    }
  },

  async deleteProduct(id, adminKey) {
    try {
      const response = await fetch(`${API_BASE}/api/products/${id}`, {
        method: 'DELETE',
        headers: {
          'X-Admin-Key': adminKey,
        },
      });
      
      return await handleResponse(response);
    } catch (error) {
      console.error('API Error in deleteProduct:', error);
      throw error;
    }
  },

  async getCart(sessionId) {
    try {
      const response = await fetch(`${API_BASE}/api/cart`, {
        headers: {
          'X-Session-Id': sessionId,
        },
      });
      
      return await handleResponse(response);
    } catch (error) {
      console.error('API Error in getCart:', error);
      throw error;
    }
  },

  async updateCart(cart, sessionId) {
    try {
      const response = await fetch(`${API_BASE}/api/cart`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Session-Id': sessionId,
        },
        body: JSON.stringify(cart),
      });
      
      return await handleResponse(response);
    } catch (error) {
      console.error('API Error in updateCart:', error);
      throw error;
    }
  },

  async getCategories() {
    try {
      const response = await fetch(`${API_BASE}/api/categories`);
      return await handleResponse(response);
    } catch (error) {
      console.error('API Error in getCategories:', error);
      throw error;
    }
  },

  async createCategory(category, adminKey) {
    try {
      const response = await fetch(`${API_BASE}/api/categories`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Admin-Key': adminKey,
        },
        body: JSON.stringify(category),
      });
      
      return await handleResponse(response);
    } catch (error) {
      console.error('API Error in createCategory:', error);
      throw error;
    }
  },

  async createOrder(orderData) {
    try {
      const response = await fetch(`${API_BASE}/api/orders`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(orderData),
      });
      
      return await handleResponse(response);
    } catch (error) {
      console.error('API Error in createOrder:', error);
      throw error;
    }
  },

  async getOrder(id) {
    try {
      const response = await fetch(`${API_BASE}/api/orders/${id}`);
      return await handleResponse(response);
    } catch (error) {
      console.error('API Error in getOrder:', error);
      throw error;
    }
  },
};
